import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=2a33ba02&scoped=true"
import script from "./Subtitle.vue?vue&type=script&lang=js"
export * from "./Subtitle.vue?vue&type=script&lang=js"
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=2a33ba02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33ba02",
  null
  
)

export default component.exports